import maxBy from "lodash.maxby";
import { Updater } from "use-immer";

import {
  ConfigType,
  ConfigurationDto,
  OrganizationSubscriptionDto,
} from "@intelligems/ig-types";

import { genericSort } from "../../../utils/sortings";

export function sortSettings(
  settings: ConfigurationDto[],
  typeSort: boolean = true
): ConfigurationDto[] {
  const optionOrder: Record<ConfigType, number> = {
    Boolean: 1,
    String: 2,
    Integer: 3,
    Float: 4,
    Json: 5,
    List: 6,
  };

  const sorted = [...settings];

  sorted.sort((a, b) => genericSort(a, b, "key"));

  if (typeSort) {
    sorted.sort((a, b) => {
      if (a.type == null || b.type == null) {
        return 0;
      }
      return optionOrder[a.type] - optionOrder[b.type];
    });
  }

  return sorted;
}

// replace current value with new value
export const onConfigChange = (
  key: string,
  newVal: any,
  setSettingsState: Updater<ConfigurationDto[]>
) => {
  setSettingsState((draft) => {
    const index = draft.findIndex((config) => config.key === key);
    draft[index].value = newVal;
    return draft;
  });
};

export const onLockedChange = (
  key: string,
  locked: boolean,
  setSettingsState: Updater<ConfigurationDto[]>
) => {
  setSettingsState((draft) => {
    const index = draft.findIndex((config) => config.key === key);
    draft[index].locked = locked;
    return draft;
  });
};

export const getNewModifiedConfigs = (
  settingsState: ConfigurationDto[],
  configurations: ConfigurationDto[]
): ConfigurationDto[] => {
  return settingsState.filter(
    (config: ConfigurationDto) =>
      JSON.stringify(config.value) !==
        JSON.stringify(
          configurations.find((c) => c.key === config.key)?.value
        ) ||
      JSON.stringify(config.locked) !==
        JSON.stringify(configurations.find((c) => c.key === config.key)?.locked)
  );
};

export function getTotalSubscriptionPrice(
  orgSubscriptions: OrganizationSubscriptionDto[]
) {
  const activeSubs = (orgSubscriptions || []).filter(
    (sub) => sub.subscriptionStatus === "active"
  );
  const totalPrice = activeSubs.reduce(
    (acc, sub) => acc + sub.subscriptionPriceUsd,
    0
  );
  const maxInterval = maxBy(activeSubs, (sub) => sub.intervalCount);

  return {
    totalPrice,
    intervalCount: maxInterval?.intervalCount || 1,
    interval: maxInterval?.subscriptionInterval || "monthly",
  };
}
